import { render } from "./PersonalReport.vue?vue&type=template&id=c45fbd4c&scoped=true&ts=true"
import script from "./PersonalReport.vue?vue&type=script&lang=ts"
export * from "./PersonalReport.vue?vue&type=script&lang=ts"

import "./PersonalReport.vue?vue&type=style&index=0&id=c45fbd4c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c45fbd4c"]])

export default __exports__